import { Fragment, useState ,useEffect} from 'react'
import { Dialog, Transition } from '@headlessui/react' 
import { BrowserRouter, Route, Link,Switch ,Redirect,useHistory} from "react-router-dom";


export default function Example(props) {
    const [show, setShow] = useState(false)
    const history = useHistory();
  return (
    
    <div className=" bg-linear-pink-invert z-50 pb-12" style={{backgroundColor:'black'}}>
    <div className="mx-auto container pt-20 lg:pt-20  flex flex-col items-center justify-center">
        <div>
            <a href="/">


        </a>
        </div>
        <div className="text-black flex flex-col md:items-center f-f-l pt-3">
            <a href="https://smartdeskph.com/"><h1 className="text-1xl  uppercase  text-white">SMART DESK PH</h1></a>
           
            <div className="md:flex items-center mb-10 text mt-5 md:mt-10 text-base text-color f-f-l">
                <h2 className=" md:mr-6 pb-4 md:py-0 text-white cursor-pointer">Email us</h2>
                <h2 className="cursor-pointer text-white"> {'sales@smartdeskph.com'} </h2>
            </div>
            <div className="my-6 text-base text-color f-f-l">
                <ul className="md:flex items-center">
                    <li  onClick={()=> window.open('https://www.facebook.com/AutonomousDesk', "_blank")  } className="text-white md:mr-6 cursor-pointer pt-4 lg:py-0">Facebook</li>
                    <li onClick={()=>window.open('https://www.instagram.com/smartdesk.ph/', "_blank")} className="text-white  md:mr-6 cursor-pointer pt-4 lg:py-0">Instagram</li>
                    <li onClick={()=>window.open('https://blog.smartdeskph.com/', "_blank")} className="text-white  md:mr-6 cursor-pointer pt-4 lg:py-0">Stories</li>
                    {/* <li onClick={()=>history.push('/TermsAndCondition')} className=" text-white md:mr-6 cursor-pointer pt-4 lg:py-0">Terms & Condition</li>
                    <li onClick={()=>history.push('/Contact')}  className="text-white cursor-pointer pt-4 lg:py-0">Contact</li> */}
                </ul>
            </div>
            <div className="text-sm text-center text-white mb-10 f-f-l">
            © 2021 SmartDeskPh rights reserved
            </div>
        </div>
        <div className="w-9/12  h-0.5 bg-gray-100 rounded-full" /> 
    </div>
</div>
)
  
}

